import Axios from "axios";
import { SETTINGS } from "../properties/Settings";

export const ExportConsignmentsRepository = {
  exportToXlsx: (searchParams, orderBy, orderDirection) => {
    const params = {};
    if (searchParams) {
      params.filterParams = JSON.stringify(searchParams);
    }

    params.orderBy = orderBy;
    params.orderDirection = orderDirection;

    return Axios.get(`${SETTINGS.API_URL}exportDeclarations/exportConsignmentsToXlsx`, {
      params,
      responseType: "blob",
    });
  },
};
